<template>
    <div>
        <div class="row">
            <div class="col-lg-7">
                <p>Employees can access all {{providerType}}</p>
            </div>
            <div class="col-lg-5">
                <div class="switch">
                    <label>
                        No
                        <input type="checkbox"
                               :value="toggle"
                               :checked="toggle"
                               @change="$emit('update:toggle', $event.target.checked)">
                        <span class="lever"></span> Yes
                    </label>
                </div>
            </div>
        </div>
        <div class="row" v-if="!toggle">
            <div style="padding:5px;">
                <div class="panel-group">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <div class="panel-title"><h5>Select one or more {{providerType}}</h5></div>
                        </div>
                        <div class="panel-body">
                            <div class="col-lg-4" style="max-height: 200px;" v-for="p in providers">
                                <input type="checkbox" class="filled-in" :id="'provider-'+p.providerEntityId" v-model="p.isChecked"
                                       @change="($event)=>{onCheckboxCheck($event,p)}">
                                <label :for="'provider-'+p.providerEntityId">
                                    <span class="">{{p.name}}</span>
                                </label>
                                <span class="col-lg-offset-1"></span>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProviderAssignment",
        props: {toggle: {required: true}, providerType: {required: true, type: [String]}, apiCall: {required: true, type: [Promise, Function]}},
        data() {
            return {
                providers: []
            }
        },
        watch: {
            toggle(newValue) {
                if (!newValue && this.providers.length == 0) {
                    this.apiCall().then((res) => this.providers = res).then((res) => this.$emit('initialProviderState', this.providers.filter(i => i.isChecked)));
                }
            }
        },
        methods: {
            onCheckboxCheck(event, provider) {
                this.$emit('providerSelection', {...provider, isChecked: event.target.checked})
            }
        }
    }
</script>

<style scoped>

</style>